import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import { connect } from 'react-redux';
import { TripPathArrow } from '../../../components/Icons/TripActionsIcon';
import { getDateInStringDDMMMYYYY } from '../../../../utils/utils';
const useStyles = makeStyles((theme) => ({
  info: {
    padding: 16,
    backgroundColor: '#fff',
    width: '100%',
    height:72,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: 'solid 1px #ddd',
  },
  viewBox:{
    marginTop:8,
    marginBottom:12,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  path: {
    //width: 70,
    color: '#ddd',
    backgroundColor: '#FFF',
    margin: '0 8px',
    flexGrow:1
  },
  location: {
    fontSize: 16,
    fontWeight: 300
  },
  date: {
    opacity: '#3c424f',
    fontSize: 12
  },
  connectDiv: {

  },
  connecter: {
    color: '#ddd',
    margin:'0 8px'
  },
  separator: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    '&.before': {
      content: '',
      flex: 1,
      borderBottom: '1px solid #000'
    },
    '&.after': {
      content: '',
      flex: 1,
      borderBottom: '1px solid #000'
    }
  },
  autoMargin: {
    //marginLeft:'auto'
  }
}));
const JourneyTripRouteCard = (props) => {
  const { location,viewBox, defaultSelected, destination, source, startDate, completedDate } = props;
  const classes = useStyles();
  const [value, setValue] = React.useState(defaultSelected ? defaultSelected : 0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className={viewBox?classes.viewBox:classes.info}>
      <div>
        <Typography className={classes.location}>
          {source ? source : ''}
        </Typography>
        <Typography className={classes.date}>
          {startDate ? getDateInStringDDMMMYYYY(startDate) : ''}
        </Typography>
      </div>
      <hr className={classes.path} />
      <TripPathArrow className={classes.connecter} />
      <hr className={classes.path} />
      <div className={classes.autoMargin}>
        <Typography className={classes.location}>
          {destination ? destination : ''}
        </Typography>
        <Typography className={classes.date}>
          {completedDate ? getDateInStringDDMMMYYYY(completedDate) : ''}
        </Typography>
      </div>
    </div>
  );
}
const JourneyTripRouteCardWithRouter = withRouter(JourneyTripRouteCard);
export default JourneyTripRouteCardWithRouter;